// import React from "react"
import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { how_it_work_image } from '../../../all_constant';
// import PickupDate from '../../../assets/images/pickup-date.png';
// import BookYourCar from '../../../assets/images/book-your-car.png';

//for redux and saga
import { connect } from 'react-redux';
import { getHowItWork } from '../../../redux/actions'


const HowitWork = (props) => {
  const { getHowitWorkAction, getHowitWorkList, loading, error, messages } = props
  // const [howItWorkData, setHowItWorkData] = useState([])

  console.log("check---", getHowitWorkList, loading, error, messages)

  React.useEffect(() => {
    // alert('calld')
    fetchData()
  }, [])

  const fetchData = () => {
    // alert("hello")
    getHowitWorkAction(1)
  }
  const regex = /(<([^>]+)>)/ig;
  const secondRegEx = /((&nbsp;))*/gmi;
  return (
    <>
    { getHowitWorkList.length > 0
      ?
      <section className="howitwork-wrap pt-100 pb-70">
         <Container>
            <Row>
              <Col md={12}>
                <h2 className="main-title">How it work</h2>
              </Col>
            </Row>
            <Row className="pt-30">
              {getHowitWorkList && getHowitWorkList.map((item) => (
                <Col md={4} className="text-center howitwork-box">
                  <span>
                    <img src={`${how_it_work_image}/${item.Icon}`} alt={item.Title} />
                  </span>
                  <h2>{item.Title}</h2>
                  <p>{item.Content.replace(regex, '').replace(secondRegEx, '')}</p>
                </Col>
              ))}
            </Row>
          </Container>
      </section>
      : <section>

          </section>
        }
      </>
  );

}

//   export default HowitWork;
const mapStateToProps = ({ howitwork }) => {
  // console.log('======', howitwork);
  const { loading, error, messages, getHowitWorkList } = howitwork;
  return { loading, error, messages, getHowitWorkList };
};

export default connect(mapStateToProps, {
  getHowitWorkAction: getHowItWork,
})(HowitWork);

